var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.info
    ? _c("div", { staticClass: "imp-banner" }, [
        _c("div", { staticClass: "imp-banner__content" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("path", { attrs: { d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n      Impersonating "),
            _c("strong", [_vm._v(_vm._s(_vm.info.target.email))]),
            _vm._v(" "),
            _c("span", { staticClass: "imp-banner__actor" }, [
              _vm._v("(as " + _vm._s(_vm.info.actor.email) + ")"),
            ]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "imp-banner__notice" }, [
            _vm._v(
              '\n      Starting a new "View as user" session will end this one.\n    '
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "imp-banner__audit" }, [
            _vm._v("All actions are audited"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "imp-banner__exit",
            attrs: { disabled: _vm.exiting },
            on: { click: _vm.exit },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.exiting ? "Exiting..." : "Exit impersonation") +
                "\n  "
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }